var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { class: ["ms-", _vm.ms.style, _vm.ms.icon, { "ms-small": _vm.small }] },
    [_vm._v(_vm._s(_vm.ms.text))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }